(function () {
  'use strict';

  var resizeFrame = 0;
  var scrollFrame = 0;

  function updateViewportHeight() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      document.documentElement.style.setProperty('--rv23-vh', (window.innerHeight * 0.01) + 'px');
    });
  }

  function updateHeaderState() {
    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(function () {
      document.body.classList.toggle('rv23-header-scrolled', window.scrollY > 12);
    });
  }

  function decodeVisibleImages(root) {
    var scope = root || document;
    scope.querySelectorAll('img[loading="eager"]').forEach(function (image) {
      if (typeof image.decode === 'function') {
        image.decode().catch(function () {});
      }
    });
  }

  function init(root) {
    decodeVisibleImages(root);
    updateViewportHeight();
    updateHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  window.addEventListener('resize', updateViewportHeight, { passive: true });
  window.addEventListener('orientationchange', updateViewportHeight, { passive: true });
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
